// extracted by mini-css-extract-plugin
export default {"root":"SocialMediaLink_root__nvCsM"};